import { Button, Icon } from "@elit-hair/elit-ui";
import { IconType } from "react-icons";

import { cn } from "@/lib/utils";

import { PRESET_ICONS } from "./icons";

type IconSelectorProps = {
    selectedIcon?: string;
    onSelect: (iconName: string) => void;
    className?: string;
    icons?: Array<{ name: string; component: IconType }>;
};

export const IconSelector = ({ selectedIcon, onSelect, className, icons = PRESET_ICONS }: IconSelectorProps) => {
    return (
        <div className={cn("space-y-3", className)}>
            <div className="max-h-[200px] overflow-y-auto p-1">
                <div className="grid grid-cols-8 gap-2">
                    {icons.map((icon) => {
                        const isSelected = selectedIcon === icon.name;
                        return (
                            <Button
                                key={icon.name}
                                onClick={() => onSelect(icon.name)}
                                variant="outline"
                                size="icon"
                                className={cn(
                                    "border-2 transition-colors",
                                    isSelected && "border-primary bg-primary/10 ring-2 ring-primary text-primary"
                                )}
                                title={icon.name}
                                aria-pressed={isSelected}
                            >
                                <Icon icon={icon.component} />
                            </Button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
